import React, { useEffect, useState } from 'react';

import { Button } from 'antd';

import AuthForm from '../../../components/AuthForm/AuthForm';
import AuthInfo from '../../../components/AuthInfo/AuthInfo';
import SignUpWrapper from '../../../SignUpWrapper';

import { resendEmailApi } from '../../../services/authApi/authApi';
import { toastNotify } from '../../../utils/toastNotify';

const ActivateAccount = () => {
  const [countDown, setCountDown] = useState(0);
  const [isShowResend, setShowResend] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    setUserEmail(localStorage.getItem('email'));
  }, [localStorage.getItem('email')]);

  //handle Resend email Link
  const handleResendEmail = async () => {
    try {
      const res = await resendEmailApi();

      if (!res.isError) {
        toastNotify('success', res?.message);
        timerCounter();
      } else {
        toastNotify('error', res?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };

  const timerCounter = (timerValue = 30) => {
    setShowResend(true);
    let timeleft = timerValue;
    const downloadTimer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(downloadTimer);
        setCountDown(0);
        setShowResend(false);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  };

  return (
    <SignUpWrapper>
      <div className='auth auth--no-info-mobile auth--activation'>
        <AuthInfo title={<>Activate your account</>} />
        <AuthForm
          title={<>Verify your email</>}
          description={
            <>
              <p>
                Check your inbox to activate your account. We sent an email to <br /> <span className='fw-600'>{userEmail}</span>
              </p>
              <p>
                The link will expire in 10 minutes. Didn’t receive an email?{' '}
                <Button
                  className='p-0 mr-8 fw-600 resend-email-btn text-terracotta h-auto'
                  type='text'
                  onClick={() => handleResendEmail()}
                  disabled={isShowResend}
                >
                  Resend email
                </Button>
                {countDown > 0 && <span>{countDown}</span>}
              </p>
            </>
          }
        ></AuthForm>
      </div>
    </SignUpWrapper>
  );
};

export default ActivateAccount;
